export default "{\n    \"label_one\": \"Team Member\",\n    \"label_other\": \"{{count}} Team Members\"\n}\n"